export var AutoMetricBlockType;
(function (AutoMetricBlockType) {
  AutoMetricBlockType["ROOT"] = "page";
  AutoMetricBlockType["SECTION"] = "section";
  AutoMetricBlockType["CONTAINER"] = "container";
  AutoMetricBlockType["ITEM"] = "item";
  AutoMetricBlockType["ELEMENT"] = "element";
})(AutoMetricBlockType || (AutoMetricBlockType = {}));
export var AutoMetricEventType;
(function (AutoMetricEventType) {
  AutoMetricEventType["CLICK"] = "click";
  AutoMetricEventType["VIEW"] = "view";
  AutoMetricEventType["CUSTOM"] = "custom";
})(AutoMetricEventType || (AutoMetricEventType = {}));